export default class TimeWindow {
	constructor({id, name, cron, duration, description, visit_point_id}) {
		this.id = id || 0;
		this.name = name || "";
		this.cron = cron || "";
		this.duration = duration || "12:00:00";
		this.description = description || "";
		this.visit_point_id = visit_point_id || [];
	}
}
